module.exports = __webpack_public_path__ + "static/media/socketErrorIcon.ac2b1ced.svg";